import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { updateField } from '../actions'

const TitleFactor = ({ hostFactor, expoFactor, busserFactor }) => {
    const dispatch = useDispatch()
    const [hf, setHostFactor] = useState(hostFactor)
    const [ef, setExpoFactor] = useState(expoFactor)
    const [bf, setBusserFactor] = useState(busserFactor)
   
    useEffect(() => {
        setHostFactor(hostFactor)
        setExpoFactor(expoFactor)
        setBusserFactor(busserFactor)
      }, [hostFactor, expoFactor, busserFactor]);
    return (
        <div>
             <span><label>Dinner Host Factor</label>
                <input type="text" name="netsales" style={{width: '50px'}} value={hf} onChange={e => setHostFactor(e.target.value)} onBlur={() => {dispatch(updateField(-1, hf, 'HOSTFACTOR'))}} />
            </span>
            <span><label>Dinner Expo Factor</label>
                <input type="text" name="netsales" style={{width: '50px'}} value={ef} onChange={e => setExpoFactor(e.target.value)} onBlur={() => {dispatch(updateField(-1, ef, 'EXPOFACTOR'))}} />
            </span>
            <span><label>Dinner Busser Factor</label>
                <input type="text" name="netsales" style={{width: '50px'}} value={bf} onChange={e => setBusserFactor(e.target.value)} onBlur={() => {dispatch(updateField(-1, bf, 'BUSSERFACTOR'))}} />
            </span>
        </div>
    )
}

export default TitleFactor